import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseService } from "../../shared/services/base.service";
import {
  RonMonitorBoardWire,
  RonMonitorOrderDetailWire,
} from "../models/ron-monitor.api-contract";
import { BoardSegmentFilter } from "../models/ron-monitor.models";
import { toDateKey } from "../ron-closing-monitor.utils";

/** The API validates against all|tsa|pa and 400s anything else, including "preferred". */
const API_SEGMENTS: Record<BoardSegmentFilter, string> = {
  all: "all",
  tsa: "tsa",
  preferred: "pa",
};

@Injectable({
  providedIn: "root",
})
export class RonMonitorService extends BaseService {
  className = "RonMonitorService";

  constructor(injector: Injector) {
    super(injector);
  }

  getBoard(
    date: Date,
    segment: BoardSegmentFilter
  ): Observable<RonMonitorBoardWire> {
    return this.getOrThrow<RonMonitorBoardWire>("/v1/ron-monitor/board", {
      date: toDateKey(date),
      segment: API_SEGMENTS[segment],
    });
  }

  getDetail(packageId: number): Observable<RonMonitorOrderDetailWire> {
    return this.getOrThrow<RonMonitorOrderDetailWire>(
      `/v1/ron-monitor/orders/${packageId}`
    );
  }

  /**
   * Not BaseService.get: it returns NEVER for a 404 whose statusText is "OK", and this
   * API sends no reason phrase, so every 404 would hang the row instead of erroring.
   */
  private getOrThrow<T>(uriPath: string, params: object = {}): Observable<T> {
    return this.getWithoutErrorHandling<T>(uriPath, params).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(
          `[${this.className}] Status code: ${error.status}, errobj:`,
          error.error
        );
        return throwError(() => error);
      })
    );
  }
}
